export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_API_URI = process.env.REACT_APP_API_URL;
export const BASE_API_V2_URI = process.env.REACT_APP_API_V2_URL;
export const BASE_PASS_KEY = process.env.REACT_APP_PASS_KEY;
export const BASE_SSN_KEY = process.env.REACT_APP_SSN_KEY;
export const BASE_MUI_KEY = process.env.REACT_APP_MUI_KEY;
export const LMS_AUTO_LOGIN_URL = process.env.REACT_APP_LMS_API_URL;
export const BASE_IDENTITY_API_URL = process.env.REACT_APP_IDENTITY_API_URL;
export const IDENTITY_CLIENT_ID = process.env.REACT_APP_IDENTITY_CLIENT_ID;

export const DEFAULT_SIZE = 4;
export const STAUTES = Object.freeze({
  PENDING: "pending",
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading",
  IDLE: "idle"
});
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;
export const DETAULT_ROLE = "Admin";
export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
export const DEFAULT_TIME_FORMAT = "hh:mm A";
export const DEFAULT_DATE_PAYLOAD_FORMAT = "YYYY-MM-DD";
export const DEFAULT_TIME_ZONE = "Europe/London";

export const STATUS_MAPPINGS = {
  SSN_NOT_ADDED: "SSN",
  RACE_NOT_ADDED: "Race",
  VS_NOT_ADDED: "VeteranStatus",
  ET_NOT_ADDED: "Ethnicity",
  EL_NOT_ADDED: "EducationalLevel",
};
